import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { CONVERTKIT } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class ConvertKitService {
  constructor(private _http: HttpClient) {}

  createAccountForm(data: any): Observable<any> {
    const postData = {
      ...data,
      api_key: CONVERTKIT.API_KEY
    };
    return this._http.post(
      `https://api.convertkit.com/v3/forms/${
        CONVERTKIT.CREATE_FROM_ID
      }/subscribe`,
      postData
    );
  }

  signupForm(data: any): Observable<any> {
    const postData = {
      ...data,
      api_key: CONVERTKIT.API_KEY
    };
    return this._http.post(
      `https://api.convertkit.com/v3/forms/${
        CONVERTKIT.SIGNUP_FORM_ID
      }/subscribe`,
      postData
    );
  }
}
